// extracted by mini-css-extract-plugin
module.exports = {"menu":"BSAIsVzhvkcbYVJNxnBqm","overlay":"_2lYRZdbG3y-nWFatOJQTS2","item":"dltdJL0cRrBDO0fq8RHz8","subItemTitle":"odN92RCEdAr9Y-kdgcl1V","subItem":"_2FhEliLivmTkxX2aiKqeb2"};